import { View, Text, Dimensions, TouchableOpacity, Image } from "react-native";
import React, { useEffect, useState } from "react";
import Modal from "react-native-modal";
import { useSelector } from "react-redux";
import MyModal from "./MyModal";
import MyInputWithLabel from "../custom/MyInputWithLabel";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import StepSlide from "../animation/StepSlide";
import { danger, gray, orange, primary, white } from "../../colors";
import CodeInput from "../custom/CodeInput";
import { height, noMoney } from "../../imports";
import getLatestTutorials from "../../api/home/getLatestTutorials";
import { TextInput } from "react-native";
import { AntDesign, Feather } from "@expo/vector-icons";
import { ScrollView } from "react-native-gesture-handler";
import newMessage from "../../api/consultation/newMessage";

const Tutorial = ({ detail, selected, setSelected }) => {
  const main = useSelector((store) => store.main);

  return (
    <TouchableOpacity
      onPress={() => setSelected(detail.id)}
      activeOpacity={1}
      style={{
        width: "100%",
        padding: 10,
        borderRadius: 10,
        borderWidth: 2,
        borderColor: selected ? primary : "#eee",
        marginBottom: 5,
      }}
    >
      <View
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <Image
          source={{ uri: detail.picURl }}
          style={{ width: 100, height: 100 }}
          resizeMode="contain"
        />
      </View>
      <MyText style={{ width: "100%", textAlign: "center", maxHeight: 50 }}>
        {main.rtl ? detail.titleFa : detail.titleEn}
      </MyText>
    </TouchableOpacity>
  );
};

export default function SendTutorialModal({ visible, setVisible, id }) {
  const [tutorials, setTutorials] = useState([]);
  const [selectedTutorial, setSelectedTutorial] = useState(null);
  const [search, setSearch] = useState("");
  const sendTutorial = () => {
    newMessage(id, "blog", selectedTutorial)
      .then(({ data }) => {
        setVisible(false);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    getLatestTutorials(99999).then(({ data }) => {
      setTutorials(data.data);
    });
  }, []);
  return (
    <Modal isVisible={visible}>
      <View
        style={{
          width: "94%",
          backgroundColor: "#fefefe",
          padding: 10,
          borderRadius: 10,
          minHeight: 200,
        }}
      >
        <View style={{ flexDirection: "row" }}>
          <TouchableOpacity onPress={() => setVisible(false)}>
            <Feather name="x" size={24} color={danger} />
          </TouchableOpacity>
          <MyText style={{ marginHorizontal: 10 }}></MyText>
        </View>

        <View
          onStartShouldSetResponder={() => true}
          style={{
            width: "100%",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <View style={{ width: "90%", marginBottom: 10 }}>
            <View
              style={{
                flexDirection: "row",
                borderRadius: 15,
                backgroundColor: white,
                borderWidth: 1,
                borderColor: gray,
              }}
            >
              <TextInput
                onChangeText={(text) => setSearch(text)}
                style={{ flex: 10, height: 40, paddingHorizontal: 10 }}
              />
              <TouchableOpacity
                style={{
                  flex: 3,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AntDesign name="search1" size={24} color="black" />
              </TouchableOpacity>
            </View>
          </View>
          <ScrollView
            keyboardShouldPersistTaps="handled"
            style={{
              width: "100%",
              maxHeight: height / 2,
              overflow: "hidden",
            }}
            contentContainerStyle={{ alignItems: "center" }}
          >
            <View
              onStartShouldSetResponder={() => true}
              style={{ width: "80%", marginBottom: 10 }}
            >
              {tutorials
                .filter(
                  (t) =>
                    t.titleFa.includes(search) || t.titleEn.includes(search)
                )
                .map((t, index) => (
                  <Tutorial
                    key={index}
                    selected={selectedTutorial === t.id}
                    detail={t}
                    setSelected={setSelectedTutorial}
                  />
                ))}
            </View>
          </ScrollView>
          <View style={{ marginVertical: 10 }}>
            <MyButton onPress={sendTutorial} text={translate("send")} />
          </View>
        </View>
      </View>
    </Modal>
  );
}
